import React from "react";

import "./DemoVideoView.css";

function DemoVideoView() {
  return (
    <div className="DemoVideoView">
      <div className="DemoVideoContainer">
        <video
          className="DemoVideoVideo"
          src="./CafeDemo.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    </div>
  );
}

export default DemoVideoView;
